import { Button } from "@mui/material";
import { User } from "../../../db_access/user";

const ButtonGenerateKey = ({ setMyInvitationKey }) => {
  const newKey = () => {
    User.generate_my_invitation_key()
      .then((res) => res.json())
      .then((data) => setMyInvitationKey(data));
  };
  return (
    <Button
      sx={{
        textTransform: "none",
        fontFamily: "Poppins",
        fontSize: "16px",
        color: "#166534",
        paddingX: 2,
        boderRadius: "5px",
        "&:hover": {
          opacity: 1,
          color: "#18183e",
          backgroundColor: "rgba(23, 163, 74, 0.2)",
        },
      }}
      onClick={() => newKey()}>
      Generate key
    </Button>
  );
};
export default ButtonGenerateKey;
